export default __webpack_public_path__ + "static/media/logo.4f6f0a11.png";